import type { AnnouncementItem } from "../../../servers/newscenter/interface"
import { AnnouncementBannerClient } from "./AnnouncementBannerClient"

interface AnnouncementBannerProps {
  announcements: AnnouncementItem[]
}

/**
 * 公告栏组件
 * @description 显示公告列表，支持自动滚动和关闭功能
 * - 单条公告且超长时：自动滚动显示完整内容
 * - 多条公告时：使用省略号并支持切换
 *
 * 优化说明：
 * - 数据验证已在服务端完成，避免客户端闪烁
 * - Cookie 检查已在服务端完成（在 HeaderContent 中）
 * - 设备类型和路径判断在服务端完成（HeaderContentWithScroll），避免客户端闪烁
 * - 如果 announcements 为空数组，说明服务端已判断不需要显示
 * - 交互逻辑封装在客户端组件中，最小化 Bundle 大小
 */
export const AnnouncementBanner = ({ announcements }: AnnouncementBannerProps) => {
  // 如果 announcements 为空，说明服务端已判断不需要显示
  if (!announcements || announcements.length === 0) {
    return null
  }

  return <AnnouncementBannerClient announcements={announcements} />
}
